import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=745cf490&"
import script from "./AddProductModal.vue?vue&type=script&lang=js&"
export * from "./AddProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports